import * as tslib_1 from "tslib";
var notificationId = 1;
export function makeNotification(type, params) {
    if (params && params.hasOwnProperty('id')) {
        var id = params.id, rest = tslib_1.__rest(params, ["id"]);
        return { id: id, type: type, params: rest };
    }
    return {
        id: notificationId++,
        type: type,
        params: params,
    };
}
//# sourceMappingURL=makeNotification.js.map